import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';

@Component({
  selector: 'app-no-decimal-input',
  standalone: false,
  templateUrl: './no-decimal-input.component.html',
  styleUrls: ['./no-decimal-input.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ] 
})
export class NoDecimalInputComponent implements OnInit {
  @Input() name: string;
  @Input() isDisabled: boolean;
  @Input() isRequired: boolean;
  @Input() value: number;
  @Input() minimumValue: number = 0;
  
  @Output() emitResult = new EventEmitter<Number>();
  

  constructor() { 
  }

  ngOnInit() { }

  public currencyInputChanged(value: string) {
    var num = value.toString().replace(/[$,]/g, "");
    this.emitResult.emit(Number(num));
  }
}
